const D = document;
window.$ = D.querySelector.bind(D);
window.$$ = (selector, startNode = D) => [...startNode.querySelectorAll(selector)];

Array.prototype.on = function(type, listener, options) {
    this.map(el => {
        if (el instanceof Element) {
            el.addEventListener(type, listener, options)
        }
    });
    return this // for chaining
};
